<template>
  <div class="f fw aic old-pb-4 bb" :class="{ 'old-pt-4': index > 0 }" v-cloak>
    <div class="cart-item__image">
      <a
        :href="[`/collections/all${item.url}`]"
        :aria-label="`link to ${item.title}`"
      >
        <img
          :src="cutOutImage ? cutOutImage : item.image"
          :alt="item.title"
          :class="[`ma block cutout-${item.handle}`]"
        />
      </a>
    </div>
    <div class="f-a cart-item__content old-pr-4">
      <div class="old-block old-mb-3">
        <a :href="item.url">
          <h3>{{ productPrefix }} {{ productTitle }}</h3>
        </a>

        <p class="old-pb-3" v-if="item.variant_title !== 'Default Title'">
          {{ item.variant_title }}
        </p>
        <p>
          <span
            v-if="hasCompareAtPrice"
            style="text-decoration: line-through"
            >{{ displayCompareAtPrice }}</span
          >
        </p>
        <p>
          <span
            v-if="!hasCompareAtPrice && isDiscounted"
            style="text-decoration: line-through"
            >{{ discountedPrice }}</span
          >
          {{ price }}
        </p>
      </div>
    </div>

    <div class="cart-item__quantity f aic jcb plaid-l ls--5">
      <div class="counter-wrapper rel inline-block">
        <div class="counter rel f cart-selectors bold fs-16">
          <button
            class="cart-quantity old-p-1 bg-dark-beige old-mr-2"
            type="button"
            @click="removeFromCart(item)"
          >
            <span>-</span>
          </button>
          <div class="counter_quantity bg-dark-beige old-p-1">
            {{ item.quantity }}
          </div>
          <button
            :class="{ disabled }"
            :disabled="disabled"
            class="cart-quantity js-add-single old-p-1 bg-dark-beige old-ml-2"
            type="button"
            @click="updateItem"
          >
            <span>+</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";

export default {
  name: "cart-line-item",
  methods: {
    ...mapActions({
      updateCart: "cart/updateCart",
      removeFromCart: "cart/removeFromCart",
    }),
    async updateItem() {
      const { key, properties, quantity } = this.item;
      if (this.disabled) return false;
      await this.updateCart({
        key,
        quantity: quantity + 1,
        properties,
      });
    },
  },
  computed: {
    ...mapState({
      cart: (state) => state.cart.data,
      variantsMetafields: (state) => state.metafields.variants,
    }),
    ...mapGetters({
      getFormattedPrice: "cart/getFormattedPrice",
      getItemsByIds: "cart/getItemsByIds",
      getProductQuantity: "cart/getProductQuantity",
      getVariantQuantity: "cart/getVariantQuantity",
      getProductSubtitle: "metafields/getProductSubtitle",
      getProductTitle: "metafields/getProductTitle",
      getProductPrefix: "metafields/getProductPrefix",
      getVariantShippingNote: "metafields/getVariantShippingNote",
      getVariantCutOutImage: "metafields/getVariantCutOutImage",
      getVariantCompareAtPrice: "metafields/getVariantCompareAtPrice",
      getVariantQuantityLimit: "metafields/getVariantQuantityLimit",
    }),
    subtitle() {
      return this.getProductSubtitle(this.item.product_id);
    },
    productTitle() {
      return this.getProductTitle(this.item.product_id);
    },
    productPrefix() {
      return this.getProductPrefix(this.item.product_id);
    },
    shippingNote() {
      return this.getVariantShippingNote(this.item.id);
    },
    cutOutImage() {
      return this.getVariantCutOutImage(this.item.id);
    },
    compareAtPrice() {
      return this.getVariantCompareAtPrice(this.item.id);
    },
    quantityLimit() {
      return this.getVariantQuantityLimit(this.item.id);
    },
    productQuantity() {
      return this.getProductQuantity(this.item.product_id);
    },
    variantQuantity() {
      return this.getVariantQuantity(this.item.id);
    },
    hasCompareAtPrice() {
      return this.compareAtPrice > 0;
    },
    displayCompareAtPrice() {
      if (!this.compareAtPrice) return null;
      return this.getFormattedPrice(this.compareAtPrice * this.item.quantity);
    },
    isDiscounted() {
      return this.item.line_price < this.item.original_line_price;
    },
    discountedPrice() {
      return this.getFormattedPrice(this.item.original_line_price);
    },
    price() {
      return this.getFormattedPrice(this.item.line_price);
    },
    disabled() {
      if (
        this.quantityLimit !== null &&
        this.quantityLimit >= this.variantQuantity
      ) {
        return true;
      }

      const itemsToReact = this.getItemsByIds(this.item.properties._reactive);
      if (!itemsToReact || !itemsToReact.length) return false;
      const itemsToReactQuantity = itemsToReact.reduce(
        (totalQuantity, _item) => totalQuantity + _item.quantity,
        0
      );
      if (itemsToReactQuantity <= this.productQuantity) {
        return true;
      }
    },
  },
  props: {
    item: Object,
    index: Number,
    vm: Array,
  },
};
</script>
